<template>
    <div>
        <v-layout row wrap class="ma-8">
            <v-flex xs12>
                <v-card class='grey lighten-4'>
                    <v-layout row wrap>

                        <v-flex xs12>
                            <h2 class="font-weight-bold text-center">Human Resource Manager Performance Evaluation</h2>
                            <v-divider class="ml-12 mr-12 mt-5"></v-divider>

                        </v-flex>


                        <v-flex xs6 class="pa-5">
                            <v-select 
                                label="Select an Employee to Review"
                                v-model="employeeName"
                                :items="users"
                                item-text="Name"
                                item-value="_id"
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 class="pa-5">
                            <v-text-field 
                                label="Date of Review"
                                v-model="employeeDate"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs3>
                            
                        </v-flex>

                        <v-flex xs3>
                           <h3>Score</h3>
                        </v-flex>

                        <v-flex xs6>
                            <h3>Task Description</h3>
                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Staffing</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing1"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Market for Jobs in all applicable job markets 
                                            where the company needs employees.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Contact all applicants for pre-screening interviews 
                                            and schedule face to face interviews.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Creating the New Hire Checklist and check references 
                                            for new hires prior to scheduling New Hire Orientation.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Collect add New Hire documents prior to the new hires attending 
                                            New Hire Orientation.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="staffing5"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            See that all trainings are scheduled for each new hire during their 
                                            first 30days with the company. NHO, CPR/FA, Safety Care, Shadow Shifts, 
                                            Friday Training Reviews, and the 90 day performance Evaluation.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="staffing6"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Create Online accounts for company software.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="staffing7"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing7}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Follow up weekly with all New Hires to see that they have 
                                            hours to work and are meeting all of their required trainings.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Employee Files</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintain and update the list of all required employee documents.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Follow up with all employees on all expiring documents and ensure that all 
                                            employees meet all required deadlines to maintain their employment.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all staff trainings are uploaded in the online system. 
                                            (Client tests, house meetings, and general staff trainings)
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Be aware of and accurately record all employee adjustments in the employee file
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Manage all employee terminations.  Including following the Employee Termination 
                                            Check list and the gathering of all adjustments, trainings, etc.  
                                            Also creating termination letters as needed and sending them to the 
                                            Corporate Attorney for review.

                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee6"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Providing access to the Insurance Broker for employees to 
                                            enroll as they choose.

                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee7"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee7}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Prepare all employee Performance Evaluations in accordance with company policy, 
                                            including the Employee Pay Change Checklist or promotion paperwork as necessary 
                                            in conjunction with the Program Coordinator.

                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="employee8"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{employee8}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that timecards are reviewed weekly. Mileage sheets complete, 
                                            and submitted by the 5th of each month.

                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Trainings</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="trainings1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{trainings1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Schedule all Annual trainings.  CPR/FA, Safety Care, etc.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="trainings2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{trainings2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff are aware of transportation policies and 
                                            procedures and are compliant. Properly train authorized employees 
                                            to drive company vehicles, complete required documentation and 
                                            properly secure individuals in safety belts and wheelchair straps.  
                                            Ensure that only authorized employees drive company vehicles and their 
                                            own vehicles for company business.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Workers Comp and Labor Laws</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="workersComp1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{workersComp1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that the company is 100% compliant with all labor laws.  
                                            See that all required labor documents are posted at the office.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="workersComp2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{workersComp2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Manage all workers compensation claims with work 
                                            med and the employee.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="workersComp3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{workersComp3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff is competent with medications, 
                                            medication forms and medication procedures.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that payroll is accurate, complete and submitted on time.  
                                            Ensure that timecards are reviewed, missing electronic punches 
                                            are explained and initialed, and employee and manager signatures 
                                            are present. Mileage sheets complete, and submitted with payroll.  
                                            Two weeks of schedules are submitted with payroll.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <!-- <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Transportation</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Turn in vehicle trip sheets with payroll. 
                                            Ensure that they are complete and accurate.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff are aware of  transportation policies 
                                            and procedures and are compliant. Properly train authorized 
                                            employees to drive company vehicles, complete required documentation 
                                            and properly secure individuals in safety belts and wheelchair straps.  
                                            Ensure that only authorized employees drive company vehicles and their 
                                            own vehicles for company business.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all individuals books are kept current, filing complete,
                                            annual forms current and ensure that related other paperwork is complete,
                                            current and audit ready.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex> -->

                        <!-- <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Medical</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that all medical needs for individuals are met.  
                                            Ensure appoints are attended and follow up is complete and 
                                            communicated to staff for appropriate follow up of doctor orders.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="medical2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate emergency room visits to supervisor, parents/guardians, 
                                            service coordinators, and others as needed.  Follow up with required paperwork 
                                            to office and DRC.  Communicate hospital stays, surgeries, etc. to appropriate 
                                            persons.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff is competent with medications, medication forms and 
                                            medication procedures.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Goals</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that individuals’ are working on their goals.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that staff know the individuals goals and assist 
                                            them as necessary.  Ensure that staff complete goal forms 
                                            accurately and on time.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Oversee that an annual meeting is held for individuals on or before the 
                                            annual date.  Complete paperwork prior to the meeting and be prepared 
                                            for the meeting.  Complete required paperwork after the meeting.  
                                            Ensure quality of forms, accuracy and forward the forms to the proper 
                                            people in a timely manner.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Complete monthly summaries accurately and on time.  
                                            Make suggestions for needed changes.  Ensure compliance of goals 
                                            from staff and ensure proper documentation in goal books.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Encourage individuals and staff get in the community and be 
                                            involved in a variety of community activities.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex> -->

                        <!-- <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Finances</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintain daily finances for individuals.  
                                            Monitor budgets, accounts and checkbooks.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Effectively follow SSA/SSI/Medicaid guidelines and policies.  
                                            Never allow accounts to exceed $2000.00 or allow accounts to have 
                                            a negative balance. Maintain all finances audit compliant as per DRC 
                                            guidelines.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure all bills are paid on time, bills are split evenly among roommates,
                                            receipts are kept, initialed by two staff persons.  Checks are signed by 
                                            individual and  staff person.  Grocery shopping is done regularly, checks 
                                            made payable to the store and cash back never received.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all money is accounted for, that individuals and 
                                            staff don not loan or borrow money or anything else.  Ensure 
                                            that individuals do not write checks to employees.
                                        </p>
                                    </v-flex>

                                </v-layout>
                            </v-card>

                        </v-flex> -->

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Personal Development</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Respond to all emails, texts and voice mails with in 
                                            6 hours of receipt
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Manage all unemployment claims with the 
                                            Program Coordinator and Executive Director
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all HR documentation is accurate and correct 
                                            as per company policy and in accordance with DRC Audit Tool.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Review and update the Employee Handbook (policies and procedures) to 
                                            ensure that it is current with applicable and require laws and company direction.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Attend all Interviews either in person or via video conference.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal6"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Attend all management meetings each week.  First Monday of each 
                                            month in person and the remaining Monday meetings via video 
                                            unless otherwise scheduled.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal7"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal7}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Be available for other impromptu meetings to discuss employee issues.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal8"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal8}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all state required investigations are completed 
                                            within the timeframe specified by the state.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal9"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal9}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all Incident Reports are completed as required by 
                                            the state and submitted as specified by the state.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12>
                            <v-card class="ma-3">
                                <v-card-title class="font-weight-bold ml-3">Overall Evaluation</v-card-title>
                                <v-layout row wrap>

                                    <v-flex xs12 class="pl-8">
                                        Evaluation Score: {{parseFloat(scoreTotal).toFixed(2)}}
                                        
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Improvement Opportunities"
                                            v-model="improvement"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Successes"
                                            v-model="successes"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs12 class="pa-6">
                                        <v-card-subtitle>This evaluation has been discussed and my questions answered.</v-card-subtitle>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Staff Name"
                                            v-model="staffName"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="staffDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Program Director"
                                            v-model="programDirector"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="programDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 class="pa-5">
                                        <v-btn @click="addReview()">Submit Review</v-btn>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-flex>

            
            
        </v-layout>

    </div>
</template>
<script>
import axios from 'axios'

const url = require("../../client_config/config").url;


export default {
    data: () => ({
        users: [],
        review: "Human Resources",
        employeeName: "",
        employeeDate: "",
        // individual1: 0,
        // individual2: 0,
        // individual3: 0,
        // individual4: 0,
        // individual5: 0,
        staffing1: 0,
        staffing2: 0,
        staffing3: 0,
        staffing4: 0,
        staffing5: 0,
        staffing6: 0,
        staffing7: 0,
        employee1: 0,
        employee2: 0,
        employee3: 0,
        employee4: 0,
        employee5: 0,
        employee6: 0,
        employee7: 0,
        employee8: 0,
        trainings1: 0,
        trainings2: 0,
        workersComp1: 0,
        workersComp2: 0,
        workersComp3: 0,
        // transportation1: 0,
        // transportation2: 0,
        // transportation3: 0,
        // medical1: 0,
        // medical2: 0,
        // medical3: 0,
        // goals1: 0,
        // goals2: 0,
        // goals3: 0,
        // goals4: 0,
        // goals5: 0,
        // finances1: 0,
        // finances2: 0,
        // finances3: 0,
        // finances4: 0,
        personal1: 0,
        personal2: 0,
        personal3: 0,
        personal4: 0,
        personal5: 0,
        personal6: 0,
        personal7: 0,
        // personal8: 0,
        // personal9: 0,
        scoreTotal: 0,
        improvement: "",
        successes: "",
        staffName: "",
        staffDate: "",
        programDirector: "",
        programDate: "",
        staffId: "",
    }),
    
    created() {
        this.getUsers()
    },

    methods: {
        getUsers() {
            axios.get(`${url}/users`).then( res => {
                this.users = res.data.users
            })
        },
        updateScore () {
            this.scoreTotal = (
                this.staffing1 
                + this.staffing2 
                + this.staffing3 
                + this.staffing4 
                + this.staffing5 
                + this.staffing6 
                + this.staffing7 
                + this.employee1 
                + this.employee2 
                + this.employee3 
                + this.employee4 
                + this.employee5 
                + this.employee6 
                + this.employee7 
                + this.employee8 
                + this.trainings1 
                + this.trainings2 
                + this.workersComp1 
                + this.workersComp2 
                + this.workersComp3 
                + this.personal1 
                + this.personal2 
                + this.personal3 
                + this.personal4 
                + this.personal5 
                + this.personal6 
                + this.personal7
                
                ) / parseInt(27)
        },

        addReview: function() {
        var req_body = {
            Review: this.review,
            EmployeeName: this.employeeName,
            EmployeeDate: this.employeeDate,
            // Individual1: this.individual1,
            // Individual2: this.individual2,
            // Individual3: this.individual3,
            // Individual4: this.individual4,
            // Individual5: this.individual5,
            Staffing1: this.staffing1,
            Staffing2: this.staffing2,
            Staffing3: this.staffing3,
            Staffing4: this.staffing4,
            Staffing5: this.staffing5,
            Staffing6: this.staffing6,
            Staffing7: this.staffing7,
            Employee1: this.employee1,
            Employee2: this.employee2,
            Employee3: this.employee3,
            Employee4: this.employee4,
            Employee5: this.employee5,
            Employee6: this.employee6,
            Employee7: this.employee7,
            Employee8: this.employee8,
            Trainings1: this.trainings1,
            Trainings2: this.trainings2,
            WorkersComp1: this.workersComp1,
            WorkersComp2: this.workersComp2,
            WorkersComp3: this.workersComp3,
            // Medical1: this.medical1,
            // Medical2: this.medical2,
            // Medical3: this.medical3,
            // Goals1: this.goals1,
            // Goals2: this.goals2,
            // Goals3: this.goals3,
            // Goals4: this.goals4,
            // Goals5: this.goals5,
            // Finances1: this.finances1,
            // Finances2: this.finances2,
            // Finances3: this.finances3,
            // Finances4: this.finances4,
            Personal1: this.personal1,
            Personal2: this.personal2,
            Personal3: this.personal3,
            Personal4: this.personal4,
            Personal5: this.personal5,
            Personal6: this.personal6,
            Personal7: this.personal7,
            ScoreTotal: this.scoreTotal,
            Improvement: this.improvement,
            Successes: this.successes,
            StaffName: this.staffName,
            StaffDate: this.staffDate,
            ProgramDirector: this.programDirector,
            ProgramDate: this.programDate,
            StaffID: this.staffID,
        };

        axios.post(`${url}/areaManager`, req_body).then((res) => {
            // this.getDiagnoses();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text = data.msg;
            });
            }
            this.employeeName= "",
            this.employeeDate= "",
            this.individual1= 0,
            this.individual2= 0,
            this.individual3= 0,
            this.individual4= 0,
            this.individual5= 0,
            this.staffing1= 0,
            this.staffing2= 0,
            this.staffing3= 0,
            this.staffing4= 0,
            this.staffing5= 0,
            this.security1= 0,
            this.security2= 0,
            this.program1= 0,
            this.program2= 0,
            this.program3= 0,
            this.program4= 0,
            this.transportation1= 0,
            this.transportation2= 0,
            this.transportation3= 0,
            this.medical1= 0,
            this.medical2= 0,
            this.medical3= 0,
            this.goals1= 0,
            this.goals2= 0,
            this.goals3= 0,
            this.goals4= 0,
            this.goals5= 0,
            this.finances1= 0,
            this.finances2= 0,
            this.finances3= 0,
            this.finances4= 0,
            this.personal1= 0,
            this.personal2= 0,
            this.personal3= 0,
            this.personal4= 0,
            this.personal5= 0,
            this.scoreTotal= 0,
            this.improvement= "",
            this.successes= "",
            this.staffName = "",
            this.staffDate = "".
            this.programDirector= "",
            this.programDate= "",
            this.msg = true;
            this.text = "The new diagnoses has been added successfully.";
        });
        this.close();
        },

    }
}
</script>